// extracted by mini-css-extract-plugin
export default {"item-list":"DessertsDesktop_item-list__NRUbO","item":"DessertsDesktop_item__px-i2","category-title":"DessertsDesktop_category-title__1y9LW"};